/* BYON · Ronda 16 (2-oct-2026): arreglos pre-Cyber en un archivo aparte (defer, desde snippets/byon-head.liquid).
   A. Hero C del home: los slides con fecha (Pre-Cyber y Cyber) solo se decidían al cargar la página. Cada 30 s, al volver
      a la pestaña y al volver con "atrás" se deciden de nuevo; si algo cambió, se arma de nuevo el carrusel
      (root.__hcBuild, de byon-home-hero-c.js). Usa la misma hora de Chile (BYONHeroC.nowCL, admite ?byon_now).
   B. Ficha: si "Agregar" falla (por ejemplo, sin stock) y el mensaje de error quedó fuera de la pantalla (barra fija del
      celular), la página baja hasta el mensaje.
   C. /cart: el ícono del carro no abre el carro lateral encima de la página (al cambiar cantidades ahí se borraban el
      subtotal y el botón de pago de /cart); sube al inicio.
   D. Landing Pre-Cyber (/pages/pre-cyber): desde las 20:00 del domingo la vitrina deja de decir «Precio secreto · Se
      revela…» y se ocultan «Por qué inscribirte» y «Así funciona»; desde el jueves 8-oct a las 00:00 (Chile) dice que el
      Cyber terminó. Sigue el data-phase que ya pone la landing.
      Ronda 17 (4-oct): en vivo y después, la bajada (.pcb-lead) deja de decir «Te avisamos el domingo…» y el botón
      «¿Dudas? Escríbenos por WhatsApp» va a la consulta 1 a 1 (wa.me), no al grupo BYON Family. */
(function () {
  'use strict';
  if (window.BYONR16) return;
  window.BYONR16 = 1;
  var W = window, D = document;
  function all(r, s) { return [].slice.call(r.querySelectorAll(s)); }

  /* A. Hero C */
  function inWin(el, n) {
    var a = el.getAttribute('data-start') || '', b = el.getAttribute('data-end') || '';
    return (!a || n >= a) && (!b || n <= b);
  }
  function hcSched() {
    var H = W.BYONHeroC, n = H && H.nowCL ? H.nowCL() : null;
    if (!n) return;
    all(D, '[data-byon-hc]').forEach(function (root) {
      var tr = root.querySelector('[data-hc-track]'), ch = 0;
      if (!tr) return;
      all(tr, '[data-sched]').forEach(function (s) {
        var t = D.getElementById(s.getAttribute('data-tab')), h = !inWin(s, n);
        if (s.hidden !== h) { s.hidden = h; ch = 1; }
        if (t && t.hidden !== h) t.hidden = h;
      });
      if (ch && typeof root.__hcBuild === 'function') root.__hcBuild();
    });
  }
  if (D.querySelector('[data-byon-hc]')) {
    setInterval(hcSched, 30000);
    D.addEventListener('visibilitychange', function () { if (!D.hidden) hcSched(); });
    W.addEventListener('pageshow', hcSched);
  }

  /* B. Error al agregar desde la barra fija */
  if (typeof subscribe === 'function' && typeof PUB_SUB_EVENTS !== 'undefined' && PUB_SUB_EVENTS.cartError) {
    subscribe(PUB_SUB_EVENTS.cartError, function () {
      setTimeout(function () {
        var w = all(D, '.product-form__error-message-wrapper').filter(function (x) { return !x.hidden && x.offsetParent !== null; })[0];
        if (!w) return;
        var r = w.getBoundingClientRect(), vh = W.innerHeight || D.documentElement.clientHeight;
        if (r.top < 0 || r.bottom > vh) w.scrollIntoView({ block: 'center', behavior: 'smooth' });
      }, 80);
    });
  }

  /* C. /cart: el ícono del carro no abre el carro lateral */
  if (D.getElementById('main-cart-items')) {
    var toTop = function (e) {
      var a = e.target && e.target.closest ? e.target.closest('#cart-icon-bubble') : null;
      if (!a) return;
      if (e.type === 'keydown' && !(e.code && e.code.toUpperCase() === 'SPACE')) return;
      e.preventDefault();
      e.stopPropagation();
      W.scrollTo({ top: 0, behavior: 'smooth' });
    };
    D.addEventListener('click', toTop, true);
    D.addEventListener('keydown', toTop, true);
  }

  /* D. Landing Pre-Cyber */
  var pcb = D.getElementById('pcb');
  if (pcb && D.getElementById('pcb-config')) {
    var OVER = Date.parse('2026-10-08T00:00:00-03:00');
    var WA1 = 'https://wa.me/56986964053?text=Hola%20BYON%2C%20tengo%20una%20consulta%20sobre%20el%20Cyber';
    var setTxt = function (el, t) { if (el && el.textContent !== t) el.textContent = t; };
    var setLast = function (el, t) {
      if (!el) return;
      var n = el.lastChild;
      if (n && n.nodeType === 3) { if (n.nodeValue !== t) n.nodeValue = t; } else el.appendChild(D.createTextNode(t));
    };
    var pcbApply = function () {
      var ph = pcb.getAttribute('data-phase');
      if (ph === 'live' || ph === 'ended') {
        all(pcb, '.pcb-prod__badge').forEach(function (b) { setTxt(b, 'VER PRECIO'); });
        all(pcb, '.pcb-prod__foot').forEach(function (f) { setLast(f, 'Toca para ver el precio de hoy'); });
        var sh = D.getElementById('pcb-show');
        if (sh) {
          setTxt(sh.querySelector('.pcb-sec__head .pcb-h2'), 'Los favoritos del Cyber');
          setTxt(sh.querySelector('.pcb-sec__head .pcb-muted'), 'Toca un producto para ver su precio de hoy.');
        }
        var why = pcb.querySelector('.pcb-why'), sec = why && why.closest('.pcb-sec');
        if (sec) sec.style.display = 'none';
        var pr = pcb.querySelector('.pcb-proof'), prs = pr && pr.closest('.pcb-sec');
        if (prs) prs.style.display = 'none';
        setTxt(pcb.querySelector('.pcb-lead'), ph === 'live' ? 'Los precios Pre-Cyber están activos hasta las 00:00.'
          : (Date.now() < OVER ? 'El CyberMonday sigue hasta el miércoles 7 de octubre a las 23:59.' : 'El Cyber BYON terminó. Revisa las ofertas vigentes.'));
        var wl = pcb.querySelector('[data-wa="live"]');
        if (wl && wl.getAttribute('href') !== WA1) wl.setAttribute('href', WA1);
      }
      if (ph === 'ended' && Date.now() >= OVER) {
        var pe = D.getElementById('pcb-p-ended');
        if (pe) {
          setTxt(pe.querySelector('.pcb-ok__title'), 'El Cyber BYON terminó');
          setTxt(pe.querySelector('.pcb-ok__text'), 'Gracias por participar. Revisa las ofertas vigentes.');
          setTxt(pe.querySelector('[data-ended-link]'), 'Ver ofertas');
        }
        setTxt(D.getElementById('pcb-final-text'), 'El Cyber BYON terminó.');
        setTxt(D.getElementById('pcb-final-btn'), 'Ver ofertas');
      }
    };
    pcbApply();
    if ('MutationObserver' in W) new MutationObserver(pcbApply).observe(pcb, { attributes: true, attributeFilter: ['data-phase'] });
    setInterval(pcbApply, 60000);
  }
})();